<template>
  <div class="analytics--creative-overview">
    <div class="analytics--creative-overview-bar">
      <h2>Creative overview</h2>
      <input-dropdown
        class="without-highlight"
        :options="trackingGroupFiltersOptions"
        placeholder="Select tracking group filter"
        :allow-empty="false"
        :preselect-first="true"
        :searchable="false"
        :show-labels="false"
        style="height: 38px"
        :track-by="null"
        :min-width="222"
        :max-width="222"
        :value="selectedTrackingGroupFilter"
        @input="updateTrackingGroupFilter"
      >
        <template #single-option="{ option }">
          {{ option.label }}
        </template>
        <template #option-row="{ option }">
          {{ option.label }}
        </template>
      </input-dropdown>
    </div>
    <analytics-stat-cards
      :analytics="designAnalytics"
      :campaign="campaign"
      class="analytics--creative-overview-cards"
      :show-bar="false"
    />
    <div
      v-if="design && tag"
      class="analytics--chart-tabs-wrapper"
    >
      <card>
        <card-body>
          <tabs
            ref="tabsEngagement"
            class="padded-cards"
            init-active-tab="engagement"
            @change-tab="changeActiveTab"
          >
            <template #content>
              <tab
                :is-active="activeTab === 'engagement'"
                title="Engagement"
              >
                <transition
                  appear
                  mode="out-in"
                  name="fadeIn"
                >
                  <engagement
                    :design="design"
                    :end-date="endDate"
                    :start-date="startDate"
                    :tag-uuid="tag.uuid"
                    :tracking-group-filter="trackingGroupFilter"
                  />
                </transition>
              </tab>
              <tab
                :is-active="activeTab === 'devices'"
                style="min-height: 440px"
                title="Devices"
              >
                <devices
                  :design-uuid="design.uuid"
                  :end-date="endDate"
                  :start-date="startDate"
                  :tag-uuid="tag.uuid"
                  :tracking-group-filter="trackingGroupFilter"
                />
              </tab>
            </template>
          </tabs>
        </card-body>
      </card>
    </div>
  </div>
</template>
<script>
import Engagement from "./Engagement.vue"
import Devices from "./Devices.vue"
import AnalyticsStatCards from "./AnalyticsStatCards.vue"
import { AnalyticsRoutes } from "@/api/routes"

export default {
  name: "CreativeOverview",
  components: {
    AnalyticsStatCards,
    Engagement,
    Devices
  },
  props: {
    design: {
      type: Object,
      default: () => ({})
    },
    tag: {
      type: Object,
      default: () => ({})
    },
    campaign: {
      type: Object,
      required: true
    },
    designAnalytics: {
      type: Object,
      default: () => ({})
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    trackingGroupFilter: {
      type: String,
      default: null
    }
  },
  emits: ["update:selectedTrackingGroupFilter"],
  data () {
    return {
      activeTab: "engagement",
      availableTrackingGroupFilters: []
    }
  },
  computed: {
    defaultTrackingGroupFilter () {
      return {
        label: "All",
        value: null
      }
    },
    trackingGroupFiltersOptions () {
      const customOptions = this.availableTrackingGroupFilters.map(filter => ({
        label: filter,
        value: filter
      }))

      return [this.defaultTrackingGroupFilter, ...customOptions]
    },
    selectedTrackingGroupFilter () {
      return this.trackingGroupFiltersOptions.find(option => option.value === this.trackingGroupFilter)
    }
  },
  mounted () {
    this.fetchAvailableTrackingGroupFilters()
  },
  methods: {
    changeActiveTab (tab) {
      this.activeTab = tab.title.toLowerCase()
    },
    async fetchAvailableTrackingGroupFilters () {
      try {
        const response = await this.$apiClient.get(AnalyticsRoutes.getAvailableTrackingGroupFilters(this.design.unique_id))
        this.availableTrackingGroupFilters = response.data?.groupFilters || []
        this.updateTrackingGroupFilter(this.defaultTrackingGroupFilter)
      } catch (error) {
        console.error("Failed to fetch tracking group filters:", error)
        this.availableTrackingGroupFilters = []
      }
    },
    updateTrackingGroupFilter (filter) {
      this.$emit("update:selectedTrackingGroupFilter", filter.value)
    }
  }
}
</script>
